import { DATE_FORMAT } from "constants/dateFormat";
import moment from "moment";

/**
 * @typedef {Object} ValueWithUnit
 * @property {number} value - The numeric value.
 * @property {string} unit - The unit of measurement.
 * @property {string} read - The human-readable representation.
 */

/**
 * @typedef {Object} WeatherDtoResponse
 * @property {Object.<string, ValueWithUnit>} [date] - Dynamic keys representing weather variables with their values.
 */

export class WeatherDto {
  static fromApi(data) {
    return constructValuesPerTime(data.daily);
  }
}

export class WeatherCumulativeDto {
  static fromApi(data) {
    const cycles = data.cycles?.map((cycle) => cycle.data) || [];
    const cyclesFlat = cycles.flat();

    const cyclesData = {};
    cyclesFlat.forEach((cycle) => {
      const { date: cycleDate, ...restCycle } = cycle;
      const date = moment(cycleDate).format(DATE_FORMAT);
      cyclesData[date] = restCycle;
    });

    return cyclesData;
  }
}

/**
 *
 * @param {any} data
 * @param {any} units
 * @returns {WeatherDtoResponse}
 */
const constructValuesPerTime = (data, units = {}) => {
  if (!data) return {};

  const { time: timeArray, ...valuesArrays } = data || {};
  const perTime = {};

  const formattedTimeArray = timeArray.map((ts) =>
    moment.unix(ts).format(DATE_FORMAT)
  );

  formattedTimeArray.forEach((date, index) => {
    perTime[date] = {};

    // variable is for example temperature_2m_max
    Object.keys(valuesArrays).forEach((variable) => {
      const value = valuesArrays[variable][index];
      const unit = units[variable];
      const read = value != null ? `${value} ${unit || ""}`.trim() : null;

      perTime[date][variable] = {
        value,
        unit,
        read,
      };
    });
  });

  return perTime;
};
